<template>
  <md-dialog :md-active.sync="modAdCentCost" :md-click-outside-to-close="false">
    <md-dialog-title class="text-center">
      {{ labels.title }}
    </md-dialog-title>

    <md-dialog-content>
      <div class="table col-md-12 mt-3">
        <table class="tblEstandar">
          <thead>
            <tr>
              <th class="thTbl">{{ labels.centroCosto }}</th>
              <th class="thTbl">{{ labels.porcentaje }}</th>
              <th class="thTbl">Acción</th>
            </tr>
          </thead>
          <tbody>
            <!-- Iteramos sobre rows para mostrar cada fila -->
            <tr v-for="(row, index) in rows" :key="index">
              <td>
                <select class="form-control" v-model="row.selCentroCosto">
                  <option value="">{{ labels.select }}</option>
                  <option
                    v-for="centroCostosSel in listCentroCostos"
                    :key="centroCostosSel.id"
                    :value="centroCostosSel.centro_costo"
                  >
                    {{ centroCostosSel.descripcion }} ({{ centroCostosSel.centro_costo }})
                  </option>
                </select>
              </td>
              <td>
                <input type="number" class="form-control" v-model="row.porcentaje">
              </td>
              <td>
                <button class="btn btn-danger" @click="removeRow(index)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="actions mt-2">
          <button class="btn btn-success" @click="addRow">{{ labels.addFila }}</button>
          <button class="btn-save" @click="saveData">{{ labels.asignar }}</button>
        </div>
      </div>
    </md-dialog-content>

    <md-dialog-actions class="md-alignment-right">
      <md-button class="md-accent" @click="cierraModal">
        {{ labels.close }}
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>


<script>
import CentroCostos from '../../services/CentroCostos'

export default {
    name: 'ModAgregarCentroCosto',
    props: ['modAdCentCost', 'vigencia'],
    data: () => ({
        listCentroCostos: [],
        rows: [
            { selCentroCosto: '', porcentaje: '' }
        ],
    }),
    computed: {
        labels() {
            if (this.$store.state._language === "es-ES") {
                return {
                    title: 'Adicionar centros de costo',
                    asignar: 'Asignar',
                    close: 'Cerrar',
                    select: 'Seleccione...',
                    noData: 'No hay Centros de Costos disponibles.',
                    centroCosto: "Centro costo",
                    descripcion: "Descripción",
                    porcentaje: "Porcentaje",
                    addFila: "Agregar fila",
                }
            } else {
                return {
                    title: 'Add cost center',
                    asignar: 'Assign',
                    close: 'Close',
                    select: 'Select...',
                    noData: 'No assets available.',
                    centroCosto: "Cost center",
                    descripcion: "Description",
                    porcentaje: "Percentage",
                    addFila: "Add row",
                }
            }
        }
    },
    methods: {
        cierraModal() {
            this.$emit('cierraModal', false)
        },
        createEmptyRow() {
            return { selCentroCosto: '', porcentaje: '' }
        },
        addRow() {
            // Validar si hay alguna fila sin seleccionar centro de costo o porcentaje
            const incompleteRow = this.rows.find(row => !row.selCentroCosto || row.porcentaje === '');
            if (incompleteRow) {
                this.$toast.error('Debe completar los datos de la fila antes de agregar otra.')
                return;
            }

            // Validar sumatoria de porcentajes
            const totalPorcentaje = this.rows.reduce((sum, r) => sum + Number(r.porcentaje), 0);
            if (totalPorcentaje >= 100) {
                this.$toast.error('La suma de los porcentajes no puede superar 100.')
                return;
            }

            this.rows.push(this.createEmptyRow());
        },
        removeRow(index) {
            this.rows.splice(index, 1)
        },
        saveData() {
            // Validar filas duplicadas
            const centros = this.rows.map(r => r.selCentroCosto);
            const hasDuplicate = new Set(centros).size !== centros.length;
            if (hasDuplicate) {
                this.$toast.error('No se pueden repetir centros de costo.')
                return;
            }

            // Validar suma de porcentajes
            const totalPorcentaje = this.rows.reduce((sum, r) => sum + Number(r.porcentaje), 0);
            if (totalPorcentaje > 100) {
                this.$toast.error('La suma de los porcentajes no puede superar 100.')
                return;
            }

            // console.log('Datos a guardar:', this.rows)
            this.$emit('asignaCentCost',this.rows)
            this.$toast.success('Centros de costo asignados.')
            return;
        }
    },
    mounted() {
        CentroCostos.getAllCentroCostos()
        .then((res) => {
            this.listCentroCostos = res.data.listCentroCostos
        })
        .catch((err) => console.log(err))
    }
}
</script>


<style>

</style>